import { css } from 'linaria';

export const productInfo = css`
  width: 430px;

  @media (--only-largeDesktop) {
    margin-top: 40px;
  }

  @media (--only-desktop) {
    width: 380px;
    margin-top: 38px;
  }

  @media (--to-desktop) {
    width: 100%;
  }
`;

export const productInfoName = css`
  max-width: 430px;

  @media (--only-mobile) {
    margin-bottom: 32px;
  }
`;

export const productInfoNameWithoutAxisPoint = css`
  && {
    margin-bottom: 32px;
  }
`;

export const productInfoDisclaimer = css`
  display: flex;
  margin-bottom: 16px;
  column-gap: 8px;
`;

export const productInfoBasketBtnWrapper = css`
  width: 280px;
  margin-bottom: 16px;

  @media (--to-desktop) {
    width: 100%;
  }
`;

export const productInfoNote = css`
  margin-bottom: 40px;
`;
